import React from "react";
import SectionToggle from "./SectionToggle";
import capacitacion from "../assets/capacitacion.jpeg";
import practica from "../assets/practicamisionera.jpeg";
import experiencia from "../assets/experiencias.jpeg";
import reporte from "../assets/reporte1.jpeg";
import costos from "../assets/costos.jpeg";

export default function InformacionPrograma() {
  return (
    <section className="informacion-programa py-5">
      <div className="container">
        <h2 className="text-center fw-bold mb-5">Lo que vivirás!</h2>

        <SectionToggle titulo="CAPACITACIÓN">
          <h4 className="text-center fw-bold mb-4" style={{ color: "#3d1042" }}>
            Capacitación Misionera
          </h4>

          <div className="row align-items-center g-4">
            {/* Imagen */}
            <div className="col-lg-5 text-center">
              <img
                src={capacitacion}
                alt="Capacitación"
                className="img-fluid rounded-4 shadow"
                style={{
                  maxHeight: "500px",
                  objectFit: "cover",
                }}
              />
            </div>

            {/* Texto */}
            <div className="col-lg-7">
              <p
                style={{
                  fontSize: "1.1rem",
                  lineHeight: "1.8",
                  textAlign: "justify",
                  fontWeight: "600",
                }}
              >
                Nuestro programa de entrenamiento misionero está diseñado para
                fortalecer la unidad del equipo, Para que los jóvenes se adapten
                a condiciones sin comodidad, memorización bíblica, capacitación
                práctica, física y espiritual, dando clases, talleres de
                evangelismo, talleres de construcción y conferencias de
                evangelismo y misiones. Adaptamos cada experiencia de campamento
                de entrenamiento a las habilidades que necesita cada equipo.
                Este entrenamiento básico se llevará a cabo en el centro de
                entrenamiento en Yangas-Canta provincia de Lima. Al finalizar el
                entrenamiento, se realizará una ceremonia de comisión o envió
                para todos los miembros y líderes del equipo antes de su partida
                hacia su práctica misionera.
              </p>
            </div>
          </div>
        </SectionToggle>

        <SectionToggle titulo="PRÁCTICA MISIONERA">
          <h4 className="text-center fw-bold mb-4" style={{ color: "#3d1042" }}>
            Práctica Misionera
          </h4>

          <div className="row align-items-center g-4">
            {/* Imagen */}
            <div className="col-lg-5 text-center">
              <img
                src={practica}
                alt="practica"
                className="img-fluid rounded-4 shadow"
                style={{
                  maxHeight: "500px",
                  objectFit: "cover",
                }}
              />
            </div>

            {/* Texto */}
            <div className="col-lg-7">
              <p
                style={{
                  fontSize: "1.1rem",
                  lineHeight: "1.8",
                  textAlign: "justify",
                  fontWeight: "600",
                }}
              >
                Cada equipo participará en diversos proyectos. En Teen Missions,
                nos esforzamos por brindar a nuestros equipos una experiencia
                ministerial variada. Lo logramos mediante evangelización
                personal, reuniones al aire libre, evangelismo de persona a
                persona, ministerio infantil, proyectos de servicio, teatros,
                títeres, música y proyectos de construcción. Los proyectos para
                cada equipo están sujetos a cambios según las necesidades de la
                iglesia u organización cristiana que recibe al equipo. ¡Queremos
                que nuestros equipos tengan espíritu de servicio y aprovechen
                las oportunidades que se les presente!
              </p>
            </div>
          </div>
        </SectionToggle>

        <SectionToggle titulo="EXPERIENCIAS TRANSCULTURALES Y TURÍSTICAS">
          <h4 className="text-center fw-bold mb-4" style={{ color: "#3d1042" }}>
            Experiencias transculturales y turísticas
          </h4>

          <div className="row align-items-center g-4">
            {/* Imagen */}
            <div className="col-lg-5 text-center">
              <img
                src={experiencia}
                alt="experiencias"
                className="img-fluid rounded-4 shadow"
                style={{
                  maxHeight: "500px",
                  objectFit: "cover",
                }}
              />
            </div>

            {/* Texto */}
            <div className="col-lg-7">
              <p
                style={{
                  fontSize: "1.1rem",
                  lineHeight: "1.8",
                  textAlign: "justify",
                  fontWeight: "600",
                }}
              >
                Cada proyecto tiene la oportunidad de interactuar y relacionarse
                con personas de una cultura diferente y costumbres variadas,
                también Nos esforzamos por incluir atractivas oportunidades para
                hacer turismo y compras en cada equipo que enviamos a sus
                proyectos. ¡Sabemos lo emocionante que es estar en un lugar
                diferente y experimentar la belleza y la diversidad de sus
                paisajes y culturas! Encontrarás información más detallada sobre
                los lugares en la sección de viajes.
              </p>
            </div>
          </div>
        </SectionToggle>

        <SectionToggle titulo="REPORTE DE PRÁCTICAS MISIONERAS">
          <h4 className="text-center fw-bold mb-4" style={{ color: "#3d1042" }}>
            Reporte de prácticas misioneras
          </h4>

          <div className="row align-items-center g-4">
            {/* Imagen */}
            <div className="col-lg-5 text-center">
              <img
                src={reporte}
                alt="reporte"
                className="img-fluid rounded-4 shadow"
                style={{
                  maxHeight: "500px",
                  objectFit: "cover",
                }}
              />
            </div>

            {/* Texto */}
            <div className="col-lg-7">
              <p
                style={{
                  fontSize: "1.1rem",
                  lineHeight: "1.8",
                  textAlign: "justify",
                  fontWeight: "600",
                }}
              >
                Para culminar la experiencia del proyecto, los equipos
                regresarán al lugar de reporte, para una sesión de reflexión y
                conjunta con otros equipos. Esta etapa es fundamental para
                nuestro programa, tanto para los miembros como para los líderes.
                Durante la reflexión, los equipos participan en diferentes
                talleres que les permiten meditar sobre su experiencia
                adquirida. Además, nos enfocamos en el compañerismo,
                compartiendo sus experiencias con los demás equipos y
                preparándolos para aplicar lo aprendido en el campo misionero en
                sus iglesias, grupos juveniles, escuelas y comunidades.
              </p>
            </div>
          </div>
        </SectionToggle>

        <SectionToggle titulo="COSTO TOTAL DEL EVENTO">
          <h4 className="text-center fw-bold mb-4" style={{ color: "#3d1042" }}>
            Costo total del evento
          </h4>

          <div className="row align-items-center g-4">
            {/* Imagen */}
            <div className="col-lg-5 text-center">
              <img
                src={costos}
                alt="costos"
                className="img-fluid rounded-4 shadow"
                style={{
                  maxHeight: "500px",
                  objectFit: "cover",
                }}
              />
            </div>

            {/* Texto */}
            <div className="col-lg-7">
              <p
                style={{
                  fontSize: "1.1rem",
                  lineHeight: "1.9",
                  textAlign: "justify",
                  fontWeight: "600",
                }}
              >
                ✓ Gastos en el entrenamiento intensivo (11 días). <br />
                ✓ Polo oficial para el proyecto. <br />
                ✓ Pasaje de ida y vuelta al proyecto misionero. <br />
                ✓ Gastos y recursos durante el proyecto (20 días). <br />
                ✓ Gastos correspondientes al reporte (3 días). <br />
                ✓ Gastos administrativos. <br />
                <br />
                <strong>No incluye:</strong> Transporte hacia el campamento de
                entrenamiento ni el regreso al lugar de origen, ropa, pasaporte,
                documentos personales, artículos de limpieza, trámites
                notariales, gastos personales ni cualquier otro artículo
                adicional requerido, los cuales serán asumidos por el
                participante.
              </p>
            </div>
          </div>
        </SectionToggle>
      </div>
    </section>
  );
}
